import script from "./SmsLogTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsLogTable.vue?vue&type=script&setup=true&lang=js"

import "./SmsLogTable.vue?vue&type=style&index=0&id=336fb3f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336fb3f0"]])

export default __exports__